import React from 'react';
import {Route, Redirect} from "react-router-dom";
import Layout from "../Layout/Layout";
import PropTypes from "prop-types";

const PrivateRoute = ({path, component: Component, auth}) => (
    <Route
        path={path}
        render={props => auth.isAuthenticated ? (
            <Layout auth={auth}>
              <Component {...props}/>
            </Layout>
        ) : (<Redirect to="/login"/>)}
    />
);

PropTypes.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute.jsx